var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaceholderImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 252,
    height: 252,
    viewBox: "0 0 252 252",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "placeholderImg",
    transform: "translate(-134 -600)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4268",
    "data-name": "Rect\\xE1ngulo 4268",
    width: 252,
    height: 252,
    transform: "translate(134 600)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5133",
    "data-name": "Grupo 5133",
    transform: "translate(223 698)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25761",
    "data-name": "Trazado 25761",
    d: "M66.379,182.848h51.337a2.276,2.276,0,0,0,1.934-3.476L93.981,138a2.276,2.276,0,0,0-3.869,0L64.444,179.372A2.276,2.276,0,0,0,66.379,182.848Z",
    transform: "translate(-64.099 -126.848)",
    fill: "#fff",
    stroke: "#f0f0f0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25762",
    "data-name": "Trazado 25762",
    d: "M215.44,231.78h38.8a2.276,2.276,0,0,0,1.934-3.476l-17.353-27.971a2.276,2.276,0,0,0-3.868,0Z",
    transform: "translate(-182.896 -175.78)",
    fill: "#fff",
    stroke: "#f0f0f0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_194",
    "data-name": "Elipse 194",
    cx: 7.37,
    cy: 7.37,
    r: 7.37,
    transform: "translate(40.398)",
    fill: "#fff",
    stroke: "#f0f0f0",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderImg);
export default __webpack_public_path__ + "static/media/placeholderImg.1bebad4baccd4bd71383afa0e0b19aff.svg";
export { ForwardRef as ReactComponent };